import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";

const defaultTheme = {
    secondaryTextColor: "#757575",
    altTextColor: "#393972",
    contrastTextColor: "#393972",
    linkTextColor: "#FD566F",
    bodyTextColor: "#444444",

    // Tag text color is the lightest color that is WAI-ARIA AA compliant
    tagTextColor: "#6e6e6e",
    tagBackgroundColor: "#f2f2f2",

    // Inspired by https://github.com/ceteio/styled-components-rhythm
    baseFontSize: 1, // 1em
    baseFontSizePx: 16,
    baseLineHeight: 1.5,
    rhythmHeight: 0.75, // em units. With browser default, this is 16px * 0.75rem == 12px
    capHeights: {
        // Calculated with https://codepen.io/sebdesign/pen/EKmbGL?editors=0011
        "Open Sans": 0.72,
    },
    contentWidth: 75,
    modularScale: (scalePosition) => {
        const scale = 1.2;
        return scale ** scalePosition;
    },
};

/*<style jsx global>{`
    body {
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI,
            Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans,
            Helvetica Neue, sans-serif;
        font-size: ${theme.baseFontSize}em;
        line-height: ${theme.baseLineHeight};
        color: ${theme.bodyTextColor};
    }
    p,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin: 0;
    }
`}</style>*/

const ThemeContext = createContext(defaultTheme);

export function ThemeProvider({ theme = {}, children }) {
    const parentTheme = useTheme();
    const localTheme = {
        ...parentTheme,
        ...theme,
    };

    return (
        <ThemeContext.Provider value={localTheme}>
            {children}
        </ThemeContext.Provider>
    );
}

ThemeProvider.propTypes = {
    theme: PropTypes.object,
    children: PropTypes.node.isRequired,
};

ThemeProvider.defaultProps = {
    theme: {},
};

export const useTheme = () => useContext(ThemeContext);
